/// <reference path="../../../node_modules/@types/globalize/index.d.ts" />

namespace Teva {
    export class Positioning {
        static GlobalZIndex = 1050;

        static GetNextZIndex() {
            return Positioning.GlobalZIndex++;
        }

        static IsFixedElement($Element) {
            return $Element.css("position") == "fixed" || $Element.parents().filter(function () { return $(this).css("position") == "fixed" }).length > 0;
        }

        static ScrollToElement($Element, Height?: number): void {
            if (Height == null)
                Height = $Element.height();
            var $Container = $Element.parents().filter(function () { return $(this).css("overflow") != "visible" }).first();
            if ($Container.length == 0 || $Container.is("html"))
                $Container = $(document.body);

            var TopOffset = 0;
            var Top;
            if ($Container.is("body")) {
                var $MainContent = $("#main-content");
                if ($MainContent.length > 0)
                    TopOffset = Number($MainContent.css("padding-top").replace("px", ""));
                Top = $Element.offset().top - TopOffset;
            }
            else
                Top = $Element.parent().scrollTop() + $Element.offset().top - $Element.parent().offset().top;
            var ContainerScrollTop = $Container.scrollTop();
            if ($Container.is("body") && ContainerScrollTop == 0)
                ContainerScrollTop = $(document.documentElement).scrollTop();
            ContainerScrollTop -= TopOffset;
            if (Top > ContainerScrollTop + $(window).height()
                || Top < ContainerScrollTop
                || (Top > ContainerScrollTop && Top + Height > ContainerScrollTop + $(window).height())) {
                if ($Container.is("body")) {
                    $("html, body").animate({
                        scrollTop: Top
                    }, 500);
                }
                else {
                    $Container.animate({
                        scrollTop: Top
                    }, 500);
                }
            }
        }
        static PositionBelow_Start($Element, $BelowElement, EventName) {
            Positioning.PositionBelow($Element, $BelowElement);
            $(window).on("resize." + EventName, function () {
                Positioning.PositionBelow($Element, $BelowElement);
            });
            $BelowElement.parents().on("scroll." + EventName, function () {
                Positioning.PositionBelow($Element, $BelowElement);
            });
        }
        static PositionBelow_Stop(BelowElement, EventName) {
            $(window).off("resize." + EventName);
            BelowElement.parents().off("scroll." + EventName);
        }

        static PositionBelow($Element, $RelativeElement) {
            if (!$RelativeElement.is(":visible"))
                $RelativeElement = $RelativeElement.closest(":visible");
            var Top = $RelativeElement.offset().top + $RelativeElement.outerHeight();
            var Left;
            if (document.body.dir == "rtl") {
                if ($RelativeElement.offset().left < 150) { // - $Element.outerWidth() + $RelativeElement.outerWidth() < 0) {
                    Left = $RelativeElement.offset().left;
                    $Element.css("max-width", (window.innerWidth - Left) + "px");
                }
                else {
                    Left = $RelativeElement.offset().left - $Element.outerWidth() + $RelativeElement.outerWidth();
                    if (Left < 0) {
                        $Element.css("max-width", $Element.outerWidth() + Left - 15);
                        Left = 15;
                    }
                }
            }
            else
                Left = $RelativeElement.offset().left
            $Element
                .css("top", Top + "px")
                .css("left", Left + "px");
        }
        static PositionFar($Element, $RelativeElement) {
            var Top = $RelativeElement.offset().top + $RelativeElement.outerHeight() / 2 - $Element.outerHeight() / 2;

            var Left;
            if (document.body.dir == "rtl") {
                Left = $RelativeElement.offset().left - $Element.outerWidth();
            }
            else
                Left = $RelativeElement.offset().left
            $Element
                .css("top", Top + "px")
                .css("left", Left + "px");
        }

        static StickyTable($Selector) {
            if (window.innerWidth < 981)
                return;

            $Selector.each(function () {
                var Table = this;
                var $Table = $(Table);
                if (Table.hasClass("table-notsticky") || $Table.closest(".modal, .og-accordion-content").length > 0)
                    return;

                Table.addClass("table-basic-entities-sticky");
                $Table.find("> thead").each(function () {
                    var Top = 0;
                    if ($Table.closest(".og-books-matching-innerscroll").length == 0)
                        Top = $(".og-navigation-bar").outerHeight();
                    $(this).find("> tr").each(function () {
                        var $Row = $(this);
                        if (!$Row.hasClass("entities-table-summaryrow"))
                            $Row.children("th").css("top", Top + "px");
                        Top += $Row.height();
                    });
                });

            });
        }

        static RemoveStickyTable($Selector) {
            $Selector.removeClass("table-basic-entities-sticky");
            $Selector.find("thead th").css("top", "");
        }
    }
}

$(document).on("Teva.PageLoad", function () {
    Teva.Positioning.StickyTable($("table"));
});
